import { useState } from 'react';

/** Owner 2026-10-24 11:15: the quote and the packlist share the switch (one preference of this device). */
const SUPPLIER_SWITCH = 'quotes.useSupplierCatalogs';
/** "Korzystaj z katalogów dostawców": a convenience of this device (browser storage), not data of the quote. */
export function useSupplierSwitch(): [boolean, (on: boolean) => void] {
  const [on, setOn] = useState(() => {
    try {
      return localStorage.getItem(SUPPLIER_SWITCH) === '1';
    } catch {
      return false;
    }
  });
  const set = (v: boolean) => {
    setOn(v);
    try {
      localStorage.setItem(SUPPLIER_SWITCH, v ? '1' : '0');
    } catch {
      /* private mode: the switch lasts while the screen is open */
    }
  };
  return [on, set];
}
